import PageLoader from '@jumbo/components/PageComponents/PageLoader';
import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';

const InteractReels = ({ match }) => {
    const requestedUrl = match.url.replace(/\/$/, '');
    return (
        <Suspense fallback={<PageLoader />}>
            <Switch>
                <Redirect exact from={`${requestedUrl}/`} to={`${requestedUrl}/watch`} />
                <Route path={`${requestedUrl}/watch`} component={lazy(() => import('./watch'))} />
                <Route path={`${requestedUrl}/comment`} component={lazy(() => import('./comment'))} />
                <Route path={`${requestedUrl}/reaction`} component={lazy(() => import('./reaction'))} />
            </Switch>
        </Suspense>
    );
};

export default InteractReels;
